<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '860px' }"
    :header="`Detalhes do Evento #${obj.id}`"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <accordion-details-vue :obj="obj" />

    <template #footer>
      <Button
        label="Fechar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Event from "../../../models/internal/event";

//Components
import AccordionDetailsVue from "./accordion-details.vue";

//Services
//import ResponsibleService from "../../../service/internal/responsible/responsible_service";
//import Responsible from "../../../models/internal/responsible";

export default {
  props: ["objSelected"],
  components: {
    AccordionDetailsVue,
  },
  data() {
    return {
      obj: new Event(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.event.dialogDetails;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.event.dialogDetails = value;
      },
    },
  },
  methods: {
    getData() {
      this.obj = this.objSelected;
      //Organizar datas do evento em ordem crescente
      this.obj.calendars = this.$CalendarUtils.sortCalendars(
        this.obj.calendars,
        "date"
      );
    },
    hideDialog() {
      this.obj = new Event();
      this.visibleDialog = false;
      this.$emit("findAll");
    },
  },
};
</script>
<style lang="scss" scoped>
.fc-sticky {
  cursor: pointer;
}
</style>
